<!-- vue快捷创建组件 -->
<template>
 <el-select  :disabled="disabled" :value="valueTitle" :clearable="clearable" @clear="clearHandle" ref="selectRef" @click.native="reLoadTree"
      filterable
      :filter-method="selectFilter"
      :placeholder="placeholder">
      <el-option :value="valueTitle" :label="valueTitle" filterable>
        <el-tree  id="tree-option"
                  ref="selectTree"
                  :accordion="accordion"
                  :data="deptTree"
                  :props="props"
                  :node-key="props.value"
                  :default-expanded-keys="defaultExpandedKey"
                  @node-click="handleNodeClick"
                  :filter-node-method="treeFilter"
                  >
        </el-tree>
    </el-option>
  </el-select>
</template>

<script>
  import DEPT_API from '@/api/api_dept';
  import pinyinMatch from 'pinyin-match'
  export default {
    name: "el-tree-select",
    props:{
      /* 配置项 */
      props:{
        type: Object,
        default:()=>{
          return {
            value:'id',             // ID字段名
            label: 'text',         // 显示名称
            children: 'children',    // 子级字段名
            // disabled:function (data,node){
            //   if(data.object.isEnterprise==1){
            //     return true;
            //   }
            // }
          }
        }

      },
      /* 选项列表数据(树形结构的对象数组) */
      options:{
        type: Array,
        require:false,
        default: ()=>{ return null }
      },
      /* 初始值 */
      value:{
        // type: Number,
        default: ()=>{ return null }
      },
      /* 可清空选项 */
      clearable:{
        type:Boolean,
        default:()=>{ return false }
      },
       /* 不可选 */
      disabled:{
        type:Boolean,
        default:()=>{ return false }
      },
      /* 自动收起 */
      accordion:{
        type:Boolean,
        default:()=>{ return false }
      },
      /* 占位文字 */
      placeholder: {
        type: String,
        default: ()=>{ return '请选择' }
      },
      showAll:{
        type: Boolean,
        default:()=>{ return false }
      },
      /* 可选企业 */
      enableSelectEnt:{
        type:Boolean,
        default:()=>{ return false }
      },
    },
    data() {
      return {
        valueId:this.value,    // 初始值
        valueTitle:'',
        defaultExpandedKey:[],
        //是否为首次触发点击函数
        treeData:[],
        isFirstCallClick:true,
        deptTree:[],
      }
    },
    mounted(){
      console.log("this.options::::",this.options);
      if(this.options==null){
          //获取部门树
          console.log("this.this.showAll::::",this.showAll);
          DEPT_API.dropDownTree({includeEnt:true,showAll:this.showAll,enable:1}).then((result) => {
            if (result && result.length > 0) {
                  this.deptTree = result;
                  this.initHandle(true);
                  this.$emit('loadAfter',this.deptTree);
                  console.log(" this.deptTree::::", this.deptTree);
              }
          });
      }else{
        this.deptTree=this.options;
        this.initHandle(true);
      }
    },
    methods: {
      // 初始化值
      initHandle(componentInit){
        this.$nextTick(()=>{
          let data = {};
          this.valueTitle = "";
          if(this.deptTree.length > 0 && this.valueId){
            let node = this.$refs.selectTree.getNode(this.valueId);
            data =  {};
            data[this.props.label] = '';
            data[this.props.value] = '';
            if(node){
              data = node.data;
            }
            this.valueTitle = data[this.props.label]     // 初始化显示
            this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
            this.defaultExpandedKey = [this.valueId]      // 设置默认展开
            //触发一波点击
            this.handleNodeClick(data,componentInit);
          }
          // else if(!componentInit && !this.valueId){
          //   //触发一波点击
          //   this.handleNodeClick(data,componentInit);
          // }


          let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
          let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
          scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
          scrollBar.forEach(ele => ele.style.width = 0)
        })

      },
      // 切换选项
      handleNodeClick(node,componentInit){
        console.log("node:::",node);
        if(!this.enableSelectEnt && node.object.isEnterprise==1){
          this.$message.error({
            showClose: true,
            message: "请选择部门",
            duration: 2000
          });
          return ;
        }
        this.valueTitle = node[this.props.label]
        this.valueId = node[this.props.value]
        let value={id: this.valueId,
            text: this.valueTitle}
        if(node["object"]){
          value.organizationType= node.object.isEnterprise==1?"E":"D";  //node["object"]["organizationType"];
        }
        if(node["parentId"]){
          value.parentId=node["parentId"];
        }
        value.object= node["object"];
        this.$emit('getValue',value,componentInit);
        this.defaultExpandedKey = [];
        let _this= this;
        setTimeout(function(){
          _this.$refs.selectRef.blur();
        },50);
        },
      // 清除选中
      clearHandle(){
        this.valueTitle = ''
        this.valueId = null
        this.defaultExpandedKey = []
        this.clearSelected()
        this.$emit('getValue',{id:'',object:{},text:''})


      },
      /* 清空选中样式 */
      clearSelected(){
        let allNode = document.querySelectorAll('#tree-option .el-tree-node')
        allNode.forEach((element)=>element.classList.remove('is-current'))
        if(this.treeData && this.treeData.length>0){
          this.deptTree = this.treeData.slice();
        }

      },
     treeFilter(query, data) {
          if (!query) {
            return true
          } else {
            const labelArray = query.split(',')
            return labelArray.some(value => {
              return value && pinyinMatch.match(data[this.props.label], value)
            })
          }
      },
      reLoadTree(){
        this.selectFilter("");
      },
      selectFilter(label) {
        console.log(" this.options::::", this.deptTree);
        console.log( this.deptTree.slice())
          this.treeData = this.deptTree.slice();
          this.$refs.selectTree.filter(label)
          return true
     },
    },
    watch: {
      value(newVal,oldVal){
        //如果新值与 旧值一样,不触发此函数
        if(newVal == oldVal){
          return;
        }
        if(!newVal){
          //如果该值无效,清空选择
          this.clearHandle();
          return;
        }
        this.valueId = newVal;
        this.initHandle(false);
      },
      options(){
        //初始化选中值
        this.deptTree=this.options;;
        this.initHandle(false);
      }
    },
  };
</script>

<style scoped>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 274px;
    padding: 0;
    line-height: 28px;
    overflow: hidden;
    overflow-y: auto;
  }

  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #409EFF;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/dept/deptedittree.vue